export default __webpack_public_path__ + "static/media/map-asia.c16c4120.jpg";